import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { MatPaginatorModule } from '@angular/material/paginator';
import { TableListComponent } from './tablelist.component';
import { ServiceGlobal } from '../../services/service.global';

@NgModule({
    imports:[
        CommonModule,
        FormsModule,
        RouterModule,
        MatPaginatorModule
    ],
    exports:[
        TableListComponent,
    ],
    declarations:[
        TableListComponent,
    ],
    providers:[
        ServiceGlobal
    ]
})

export class TableListModule{}



// WEBPACK FOOTER //
// ./src/app/common/component/tablelist/tablelist.module.ts